import io from "socket.io-client/dist/socket.io";
import { ENV } from "../config/env";
import { log, errorLog } from "utils/logger";
import { getSessionDataOnlyRead, getSessionData } from "utils/common";

let socket = null;
let lastToken = null;

export function getSocket() {
  // IMPORTANT: return the existing instance even if it's reconnecting.
  // Creating a new socket when `connected === false` causes multiple parallel connections,
  // rapid connect/disconnect logs, and can indirectly break chart rendering.
  if (socket) {
    const sess = getSessionDataOnlyRead() || getSessionData() || {};
    const token = sess.token || sess.Token || null;
    // If user/session changed, rebuild the socket with the new token.
    if (token && token !== lastToken) {
      try { socket.disconnect(); } catch {}
      socket = null;
    } else {
      return socket;
    }
  }

  const sess = getSessionDataOnlyRead() || getSessionData() || {};
  const token = sess.token || sess.Token;
  lastToken = token || null;
  const bearerToken = token ? `Bearer ${token}` : "";

  socket = io(ENV.SOCKET_URL, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 20,
    reconnectionDelay: 2000,
    timeout: 20000,
    // v2 server expects token in query during handshake
    query: token ? `token=${encodeURIComponent(token)}&bearerToken=${encodeURIComponent(bearerToken)}` : "",
  });

  socket.on("connect", () => {
    log("Socket connected");
  });

  socket.on("disconnect", () => {
    log("Socket disconnected");
  });

  socket.on("connect_error", (err) => {
    errorLog("Socket error", err?.message || err);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
    lastToken = null;
    log("Socket manually disconnected");
  }
}

export default getSocket;